import { render, staticRenderFns } from "./BigButton.vue?vue&type=template&id=326e28e8&"
import script from "./BigButton.vue?vue&type=script&lang=ts&"
export * from "./BigButton.vue?vue&type=script&lang=ts&"
import style0 from "./BigButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports